module.exports = __webpack_public_path__ + "img/login_ic_wechat.0dc0587.png";